import { gsap, Power3 } from 'gsap'
import { getFadeUpElements, getSplitElements } from './setup'

function runTextAnimation(container)
{

  let splitLines = container.find(getSplitElements())
  let fadeUpElements = container.find(getFadeUpElements())
  let blockLines = container.find('.js-block-line-animation')
  let fadeUpDelay = 0

  if(splitLines.length) {
    fadeUpDelay = 0.75
    gsap.to(splitLines, {
      y: 0,
      duration: 1.5,
      ease: Power3.easeOut,
    })
  }

  if(fadeUpElements.length) {
    gsap.to(fadeUpElements, {
      delay: fadeUpDelay,
      y: '0%',
      opacity: 1,
      stagger: 0.15,
      ease: Power3.easeOut,
      duration: 1.25
    })
    gsap.to(blockLines, {
      delay: fadeUpDelay + 0.5,
      "clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
      ease: Power3.easeOut,
      duration: 1.25
    })
  }

}

export { runTextAnimation }
